import React, { useEffect, useRef } from "react";
import { Button, Container, Input } from "reactstrap";
import { IoCloseSharp } from "react-icons/io5";
import CustomSelect from "../../../Components/CustomSelect/CustomSelect";
import { FaSearch } from "react-icons/fa";
const AssignmentForm1 = ({
  payload,
  handleChange,
  rest,
  error,
  isError,
  setIsError,
  formData,
  pathname
}) => {
  const questionRef = useRef(null);
  const referenceRef = useRef(null);
  useEffect(() => {
    questionRef.current.addEventListener("dragover", handleQuestionDragOver);
    questionRef.current.addEventListener("drop", handleQuestionDrop);
    return () => {
      questionRef.current?.removeEventListener(
        "dragover",
        handleQuestionDragOver,
      );
      questionRef.current?.removeEventListener("drop", handleQuestionDrop);
    };
  }, []);

  const handleQuestionDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleQuestionDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer;

    if (files && files.length) {
      // onUpload(files);
      const event = {
        target: {
          files: files,
          name: "questionPDF",
        },
      };
      handleChange(event);
    }
  };

  useEffect(() => {
    if (payload?.haveReferenceFile === "Yes") {
      referenceRef.current.addEventListener(
        "dragover",
        handleReferenceDragOver,
      );
      referenceRef.current.addEventListener("drop", handleReferenceDrop);
    }

    return () => {
      referenceRef.current?.removeEventListener(
        "dragover",
        handleReferenceDragOver,
      );
      referenceRef.current?.removeEventListener("drop", handleReferenceDrop);
    };
  }, [payload?.haveReferenceFile]);




  const handleReferenceDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleReferenceDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer;

    if (files && files.length) {
      // onUpload(files);
      const event = {
        target: {
          files: files,
          name: "referencePDF",
        },
      };
      handleChange(event);
    }
  };

  const subCategoryOptions = rest?.categories?.map((data) => ({
    value: data._id,
    label: data.name,
    image: data.image,
    categoryId: data.categoryId,
    path: data?.path
  }));

  useEffect(() => {
  if (!pathname || !rest?.categories) return;

  const matchedCategory = rest.categories.find(
    (item) => item.path === pathname
  );

  if (matchedCategory && !payload?.subCategory) {
    handleChange({
      target: {
        name: "subCategory",
        value: matchedCategory._id,
        categoryId: matchedCategory.categoryId
      },
    });
  }
}, [pathname, rest?.categories]);
  const subjectOptions = formData?.subject?.map((data) => ({
    value: data._id,
    label: data.subSubjectName,
    image: data.image,
    parent:data?.subjectId?.questionSubject
  }));


  return (
    <Container>
      <h1 className="step-header text-center mb-3">Upload Assignment</h1>
      <div className="row py-3 g-3">
        <div className="col-md-6">
          <CustomSelect
            name="subCategory"
            options={subCategoryOptions}
            value={payload?.subCategory}
            placeholder="Select Assignment Type"
            handleChange={handleChange}
            error={error?.subCategory}
            icon={FaSearch}
          />
        </div>
        <div className="col-md-6">
          <CustomSelect
            name="subject"
            options={subjectOptions}
            value={payload?.subject}
            placeholder="Select your subject"
            handleChange={handleChange}
            error={error?.subject}
            icon={FaSearch}
          />
        </div>

        <div className="col-md-6 mb-3 ">
          <div className="place-your-writing-container">
            <label
              htmlFor="uploadQuestionPDF"
              className="place-your-writing-label"
            >
              <div className="upload-file-container" ref={questionRef}>
                <span>
                  Drop your File or <span className="text-primary">Browse</span>
                </span>
              </div>
              <input
                type="file"
                hidden
                multiple
                id="uploadQuestionPDF"
                name="questionPDF"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf,.html,.htm,.xml,.json,.js,.css,.java,.py,.cpp,.cs,.rb,.php,.swift,.pl,.sh,.bat,.ps1,.vbs,.asm,.c,.h,.cpp,.hpp,.cs,.java,.jar,.py,.rb,.pl,.php,.shtml,.asp,.aspx,.jsp,.aspx,.jsp,.cfm,.actionscript,.sgf,.wasm,.unity,.gmx,.gmz,.love,.ase,.aseprite,.atlas,.png,.jpg,.jpeg"
                onChange={handleChange}
              />
            </label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="place-your-writing-container">
            <textarea
              name="question"
              id="typeYourQuestion"
              style={{ borderRadius: "inherit" }}
              placeholder="Type your questions here"
              value={payload?.question}
              onChange={handleChange}
            ></textarea>
          </div>
          {isError && error.questionPDF !== "" && (
            <span
              className="text-danger mt-2 d-block"
              style={{ fontSize: "12px" }}
            >
              {error.questionPDF}
            </span>
          )}
        </div>
        <div className="w-auto path-contents">
          {payload?.questionPDF &&
            payload?.questionPDF?.map((file, index) => (
              <div className="row reference-section mt-3 rounded ">
                <div>
                  <div className="text-primary fs-5 border auto-width mx-2">
                    <span className="mx-2">{file.name}</span>
                    <button
                      className="btnClose ms-1 "
                      onClick={() =>
                        rest?.handleRemoveFile(index, "questionPDF")
                      }
                      style={{ zIndex: 1 }}
                      type="button"
                    >
                      <IoCloseSharp className="text-center mb-1" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* <div className="row py-2">
        <div className="col-md-12 mb-2">
          <h5 className="text-center">
            Please send your Zip File in google drive link and share the link
            question text !
          </h5>
        </div>
      </div> */}
      <div className="row border border-1 reference-section m-1">
        <div className="col-md-6 p-0 fs-3 text-center d-flex flex-column gap-2">
          <b>Have Reference File :</b>
          <span className="d-flex gap-3 justify-content-center align-items-center">
            <Input
              type="radio"
              onChange={handleChange}
              name="haveReferenceFile"
              value={"Yes"}
              checked={payload?.haveReferenceFile === "Yes"}
            />
            Yes
            <Input
              type="radio"
              onChange={handleChange}
              name="haveReferenceFile"
              value={"No"}
              checked={payload?.haveReferenceFile !== "Yes"}
            />
            No
          </span>
        </div>
        <div
          className="col-md-6 p-0 "
          style={{
            opacity: payload?.haveReferenceFile
              ? payload?.haveReferenceFile === "No"
                ? 0.5
                : ""
              : 0.5,
          }}
        >
          <div className="place-your-writing-container">
            <label
              htmlFor="uploadReferencePDF"
              className="place-your-writing-label"
            >
              <div className="upload-file-container" ref={referenceRef}>
                <span>
                  Drop your File or <span className="text-primary">Browse</span>
                </span>
              </div>
              <input
                type="file"
                hidden
                multiple
                disabled={payload?.haveReferenceFile !== "Yes"}
                id="uploadReferencePDF"
                name="referencePDF"
                onChange={
                  payload?.haveReferenceFile
                    ? payload?.haveReferenceFile === "Yes"
                      ? handleChange
                      : () => {}
                    : () => {}
                }
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf,.html,.htm,.xml,.json,.js,.css,.java,.py,.cpp,.cs,.rb,.php,.swift,.pl,.sh,.bat,.ps1,.vbs,.asm,.c,.h,.cpp,.hpp,.cs,.java,.jar,.py,.rb,.pl,.php,.shtml,.asp,.aspx,.jsp,.aspx,.jsp,.cfm,.actionscript,.sgf,.wasm,.unity,.gmx,.gmz,.love,.ase,.aseprite,.atlas,.png,.jpg,.jpeg"
              />
            </label>
          </div>
        </div>
      </div>
      {isError && error.referencePDF !== "" && (
        <span className="text-danger mt-2 d-block" style={{ fontSize: "12px" }}>
          {error.referencePDF}
        </span>
      )}
      <div className="row py-3">
        <div className="w-auto path-contents">
          {payload?.referencePDF &&
            payload?.referencePDF?.map((file, index) => (
              <div className="row reference-section mt-3 rounded">
                <div>
                  <div className="text-primary fs-5 border auto-width mx-2">
                    <span className="mx-2">{file.name}</span>
                    <button
                      className="btnClose ms-1"
                      onClick={() =>
                        rest?.handleRemoveFile(index, "referencePDF")
                      }
                      style={{ zIndex: 1 }}
                      type="button"
                    >
                      <IoCloseSharp className="text-center mb-1" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Container>
  );
};

export default AssignmentForm1;
